var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      height: 512,
      width: 512
    },
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    className: "",
    style: {},
    transform: "translate(0,0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M131.656 49.656 22.312 159l12.344 12.344 46.813-28.906 32.686-32.688-.062-.063L144 62l-12.344-12.344zm247.688 0L367 62l26.906 43.563 37.688 37.687 44.75 28.094L488.688 159 379.344 49.656zm4.906 72.688L371.094 135.5l20.687 20.688-32.81-8.594-10.97 11 21.03 21.03-33.342-8.75-10.782 10.814 21.375 21.375-33.874-8.907L87.97 418.626 66.405 472.03l53.313-21.655L416 154.095l-31.75-31.75zm-256.875.625-31.75 31.75 10.656 10.655 21-21-8.718 33.28 10.813 10.814 21.344-21.345-8.876 33.813 10.625 10.625 21.686-21.688-9.03 34.344 45.56 45.56 31.75-31.75-115.06-115.06zm172.938 172.905-31.75 31.75 122.75 122.75 53.375 21.563-21.657-53.313-122.717-122.75z",
    fill: "#000000",
    fillOpacity: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNails);
export default __webpack_public_path__ + "static/media/nails.4e6d8f420557aed30da5ff8d5d69f0bc.svg";
export { ForwardRef as ReactComponent };